// :cow: Cosmose CONFIDENTIAL :iso:
import { Component } from '@angular/core';

@Component({
  selector: 'e-page-404',
  templateUrl: 'page-404.component.html',
})
export class Page404Component {
}
